(() => {
  const likeElemTimers = window.WeakMap ? new WeakMap() : new Map();

  window.swinger.i18n()
    .then((i18n) => {
      const update = (elem) => {
        window.clearTimeout(likeElemTimers.get(elem));
        likeElemTimers.set(elem, window.setTimeout(() => {
          const itemType = elem.getAttribute('data-like-type');
          const itemId = elem.getAttribute('data-like-id');
          const isLiked = window.swinger.user.getItemLikedState(itemType, itemId);
          const number = elem.getAttribute('data-like-number');
          const addLikeAction = i18n(`ui.data-like.${itemType}.add`, { number });
          const removeLikeAction = i18n(`ui.data-like.${itemType}.remove`, { number });

          elem.setAttribute('role', 'switch');
          elem.setAttribute('tabindex', '0');

          if (window.swinger.user.isLoggedIn() && isLiked) {
            elem.setAttribute('aria-checked', 'true');

            if (elem.hasAttribute('aria-label')) {
              elem.setAttribute('aria-label', removeLikeAction);
            } else {
              elem.innerText = removeLikeAction;
            }
            if (elem.hasAttribute('aria-labelledby')) {
              const current = elem.getAttribute('aria-labelledby');
              const parts = current.split(' ');
              const updated = parts
                .map((part) => (part.startsWith('swinger-aria-like__') && part.endsWith('-add')
                  ? `${part.slice(0, -4)}-remove`
                  : part))
                .join(' ');
              elem.setAttribute('aria-labelledby', updated);
            }
          } else {
            elem.setAttribute('aria-checked', 'false');

            if (elem.hasAttribute('aria-label')) {
              elem.setAttribute('aria-label', addLikeAction);
            } else {
              elem.innerText = addLikeAction;
            }
            if (elem.hasAttribute('aria-labelledby')) {
              const current = elem.getAttribute('aria-labelledby');
              const parts = current.split(' ');
              const updated = parts
                .map((part) => (part.startsWith('swinger-aria-like__') && part.endsWith('-remove')
                  ? `${part.slice(0, -7)}add`
                  : part))
                .join(' ');
              elem.setAttribute('aria-labelledby', updated);
            }
          }
        }, 100));
      };

      window.swinger.eventHub.register('click', '[data-like]', (e) => {
        if (!window.swinger.user.isLoggedIn()) {
          return;
        }

        const elem = window.swinger.eventHub.getTarget(e).closest('[data-like]');
        const itemType = elem.getAttribute('data-like-type');
        const itemId = elem.getAttribute('data-like-id');
        const isLiked = elem.matches('[aria-checked="true"]');
        const number = elem.getAttribute('data-like-number');

        if (window.swinger.eventHub) {
          window.swinger.eventHub.trigger(document, 'swinger.data-like:toggled', {
            elem,
            itemType,
            itemId,
            isLiked,
          });
        }

        window.swinger.user.setItemLikeState(itemType, itemId, !isLiked);
        if (!isLiked) {
          window.swinger.tracking.trackAddToWishlist(itemId);
        }

        update(elem);

        if (isLiked) {
          window.swinger.snackbar.create({
            isSelfclosing: true,
            children: [
              {
                component: 'notification',
                data: {
                  type: 'success',
                  text: i18n('ui.data-like.remove-success-message', { number }),
                },
              },
            ],
          });
        } else {
          window.swinger.snackbar.create({
            isSelfclosing: true,
            children: [
              {
                component: 'notification',
                data: {
                  type: 'success',
                  text: i18n('ui.data-like.add-success-message', { number }),
                },
              },
            ],
          });
        }

        elem.classList.add('was-just-toggled');
        window.setTimeout(() => {
          elem.classList.remove('was-just-toggled');
        }, 1300);
      });

      window.swinger.observer.initialize('[data-like]', (elem) => {
        if (!elem.hasAttribute('role')) {
          elem.setAttribute('role', 'switch');
        }
        if (!elem.matches(window.swinger.focusableElements.join(','))) {
          elem.setAttribute('tabindex', '0');
        }

        document.addEventListener('swinger.user:authchange', () => {
          update(elem);
        });

        document.addEventListener('swinger-widget:rendered', (e) => {
          const target = window.swinger.eventHub.getTarget(e);

          if (target.contains && !target.contains(elem)) {
            return;
          }

          update(elem);
        });

        update(elem);
      }, false);
    })
    .catch(console.info);
})();
